import { render, staticRenderFns } from "./productionSubcontract.vue?vue&type=template&id=92a5bfea&scoped=true"
import script from "./productionSubcontract.vue?vue&type=script&lang=js"
export * from "./productionSubcontract.vue?vue&type=script&lang=js"
import style0 from "./productionSubcontract.vue?vue&type=style&index=0&id=92a5bfea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a5bfea",
  null
  
)

export default component.exports